var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big-box"},[_c('MBHeaderNav'),_c('router-view'),(_vm.showFooter)?_c('MBFooterInfo'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }